import React, { useState } from 'react';
import { ASSETS } from '../constants/assets';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import { Avatar, AvatarImage, AvatarFallback } from '../components/Avatar';
import { Badge } from '../components/Badge';
import { ChevronRight, Sparkles, Map, Heart, Calendar, Shield, Ticket, MessageSquare, Info, TrendingUp, Trophy, Home as HomeIcon, Compass } from 'lucide-react';
import { toast } from 'sonner';
const serviceEntries = [{
  icon: Map,
  title: '我的路线',
  color: 'text-blue-500'
}, {
  icon: Heart,
  title: '我的收藏',
  color: 'text-red-500'
}, {
  icon: Calendar,
  title: '我的预约',
  color: 'text-green-500'
}, {
  icon: Shield,
  title: '长者版',
  color: 'text-orange-500'
}, {
  icon: Trophy,
  title: '赛事服务',
  color: 'text-purple-500'
}, {
  icon: Ticket,
  title: '消费券',
  color: 'text-yellow-500'
}, {
  icon: MessageSquare,
  title: '意见反馈',
  color: 'text-cyan-500'
}, {
  icon: Info,
  title: '关于项目',
  color: 'text-gray-500'
}];
const timeOptions = ['半日游', '一日游', '两日游', '周末游'];
const prefOptions = ['历史文化', '红色旅游', '自然生态', '亲子休闲', '非遗体验', '研学旅行', '美食打卡', '赛事观光'];
export function Services() {
  const [selectedTime, setSelectedTime] = useState('一日游');
  const [selectedPref, setSelectedPref] = useState('历史文化');
  const [selectedPeople, setSelectedPeople] = useState('单人');
  const [selectedMode, setSelectedMode] = useState('自驾');
  const [showResult, setShowResult] = useState(false);
  const handleGenerate = () => {
    toast.success(`正在为您生成 ${selectedTime} · ${selectedPref} · ${selectedPeople} 专属路线...`);
    setTimeout(() => setShowResult(true), 1500);
  };
  return <div className="min-h-screen bg-[#EEF8F8] pb-24" data-id="element-356">
      {/* User Welcome Card */}
      <div className="relative h-64 w-full overflow-hidden rounded-b-[64rpx] shadow-lg" data-id="element-357">
        <img src={ASSETS.searchBg} alt="Welcome Bg" className="w-full h-full object-cover" data-id="element-358" />
        <div className="absolute inset-0 bg-black/10 backdrop-blur-[2px]" data-id="element-359" />
        <div className="absolute inset-0 flex flex-col items-center justify-end p-8 pb-12" data-id="element-360">
          <div className="flex items-center gap-4 mb-6" data-id="element-361">
            <Avatar className="size-16 border-2 border-white/50 shadow-xl" data-id="element-362">
              <AvatarImage src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=100&h=100&fit=crop" data-id="element-363" />
              <AvatarFallback data-id="element-364">微信用户</AvatarFallback>
            </Avatar>
            <div className="text-white" data-id="element-365">
              <h1 className="text-2xl font-bold" data-id="element-366">你好，微信用户</h1>
              <p className="text-white/80 text-sm mt-1" data-id="element-367">
                欢迎来到宿州，今天想怎么玩？
              </p>
            </div>
          </div>
          <div className="flex items-center justify-center gap-8 text-white/90 w-full" data-id="element-368">
            <div className="flex flex-col items-center" data-id="element-369">
              <span className="text-lg font-bold" data-id="element-370">6</span>
              <span className="text-[18rpx] opacity-80 text-[14px]" data-id="element-371">
                我的收藏
              </span>
            </div>
            <div className="w-px h-8 bg-white/20" data-id="element-372" />
            <div className="flex flex-col items-center" data-id="element-373">
              <span className="text-lg font-bold" data-id="element-374">3</span>
              <span className="text-[18rpx] opacity-80 text-[14px]" data-id="element-375">
                我的路线
              </span>
            </div>
            <div className="w-px h-8 bg-white/20" data-id="element-376" />
            <div className="flex flex-col items-center" data-id="element-377">
              <span className="text-lg font-bold" data-id="element-378">2</span>
              <span className="text-[18rpx] opacity-80 text-[14px]" data-id="element-379">
                我的优惠券
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 -mt-6 relative z-10 flex flex-col gap-6" data-id="element-380">
        {/* AI Travel Guide Module */}
        <Card className="p-6 bg-white border-none shadow-xl rounded-[40rpx] overflow-hidden relative" data-id="element-381">
          <div className="relative z-10" data-id="element-382">
            <div className="flex items-center justify-between mb-4" data-id="element-383">
              <div className="flex items-center gap-2 text-[#66CADA]" data-id="element-384">
                <Sparkles className="size-5 fill-current" data-id="element-385" />
                <span className="text-sm font-bold" data-id="element-386">AI 智游宿州</span>
              </div>
              <span className="text-[18rpx] text-[#999999]" data-id="element-387">
                选择偏好，一键生成专属路线
              </span>
            </div>

            <div className="flex flex-col gap-4 mb-6" data-id="element-388">
              <div data-id="element-389">
                <span className="text-[22rpx] text-[#999999] block mb-2 font-medium" data-id="element-390">
                  出行时间
                </span>
                <div className="flex flex-wrap gap-2" data-id="element-391">
                  {['半日游', '一日游', '两日游', '周末游'].map(opt => <Badge key={opt} onClick={() => setSelectedTime(opt)} className={`cursor-pointer border-none px-3 py-1 rounded-lg transition-all ${selectedTime === opt ? 'bg-[#66CADA] text-white' : 'bg-[#EEF8F8] text-[#666666]'}`} data-id="element-392">
                      {opt}
                    </Badge>)}
                </div>
              </div>
              <div data-id="element-393">
                <span className="text-[22rpx] text-[#999999] block mb-2 font-medium" data-id="element-394">
                  出行偏好
                </span>
                <div className="flex flex-wrap gap-2" data-id="element-395">
                  {['历史文化', '红色旅游', '自然生态', '亲子休闲', '非遗体验', '研学旅行', '美食打卡', '赛事观光'].map(opt => <Badge key={opt} onClick={() => setSelectedPref(opt)} className={`cursor-pointer border-none px-3 py-1 rounded-lg transition-all ${selectedPref === opt ? 'bg-[#66CADA] text-white' : 'bg-[#EEF8F8] text-[#666666]'}`} data-id="element-396">
                      {opt}
                    </Badge>)}
                </div>
              </div>
              <div data-id="element-397">
                <span className="text-[22rpx] text-[#999999] block mb-2 font-medium" data-id="element-398">
                  出行人群
                </span>
                <div className="flex flex-wrap gap-2" data-id="element-399">
                  {['单人', '情侣', '亲子家庭', '大学生', '银发游客', '运动会观众'].map(opt => <Badge key={opt} onClick={() => setSelectedPeople(opt)} className={`cursor-pointer border-none px-3 py-1 rounded-lg transition-all ${selectedPeople === opt ? 'bg-[#66CADA] text-white' : 'bg-[#EEF8F8] text-[#666666]'}`} data-id="element-400">
                      {opt}
                    </Badge>)}
                </div>
              </div>
              <div data-id="element-401">
                <span className="text-[22rpx] text-[#999999] block mb-2 font-medium" data-id="element-402">
                  出行方式
                </span>
                <div className="flex flex-wrap gap-2" data-id="element-403">
                  {['自驾', '公交', '步行', '打车', '骑行'].map(opt => <Badge key={opt} onClick={() => setSelectedMode(opt)} className={`cursor-pointer border-none px-3 py-1 rounded-lg transition-all ${selectedMode === opt ? 'bg-[#66CADA] text-white' : 'bg-[#EEF8F8] text-[#666666]'}`} data-id="element-404">
                      {opt}
                    </Badge>)}
                </div>
              </div>
            </div>

            <Button onClick={handleGenerate} className="w-full bg-[#66CADA] hover:bg-[#2BAABD] text-white rounded-full py-6 font-bold shadow-lg shadow-[#66CADA]/20" data-id="element-405">
              生成我的路线
            </Button>
          </div>
          <div className="absolute top-0 right-0 w-32 h-32 bg-[#66CADA]/5 rounded-full -mr-16 -mt-16 blur-2xl" data-id="element-406" />
        </Card>

        {/* AI Result Section */}
        {showResult && <div className="flex flex-col gap-4 animate-in fade-in slide-in-from-top-4 duration-500" data-id="element-407">
            <div className="flex items-center justify-between" data-id="element-408">
              <h3 className="text-lg font-bold text-[#333333]" data-id="element-409">推荐路线结果</h3>
              <span className="text-xs text-[#999999]" data-id="element-410">根据您的偏好生成</span>
            </div>
            <Card className="overflow-hidden border-none shadow-md rounded-[32rpx] bg-white" data-id="element-411">
              <div className="h-40 relative" data-id="element-412">
                <img src={ASSETS.detailRouteDefault} alt="Route" className="w-full h-full object-cover" data-id="element-413" />
                <div className="absolute top-3 left-3 bg-[#66CADA] text-white text-[18rpx] px-2 py-0.5 rounded-full" data-id="element-414">
                  {selectedTime} · {selectedPref} · {selectedPeople}
                </div>
              </div>
              <div className="p-4" data-id="element-415">
                <h4 className="font-bold text-[#333333] text-base mb-2" data-id="element-416">
                  宿州城市文化精品游
                </h4>
                <div className="flex flex-wrap gap-2 mb-3" data-id="element-417">
                  {['宿州市博物馆', '新汴河景区', '宿州城市书房'].map(stop => <span key={stop} className="text-[20rpx] text-[#666666] bg-gray-50 px-2 py-0.5 rounded" data-id="element-418">
                        {stop}
                      </span>)}
                </div>
                <p className="text-[20rpx] text-[#999999] leading-relaxed" data-id="element-419">
                  适合{selectedPeople}到访宿州，以{selectedMode}
                  方式深度体验城市文化与滨水休闲。
                </p>
                <div className="mt-4 pt-4 border-t border-gray-50 flex items-center justify-between" data-id="element-420">
                  <span className="text-[20rpx] text-[#999999]" data-id="element-421">
                    预估费用：0-80元
                  </span>
                  <Button size="sm" className="bg-[#EEF8F8] text-[#66CADA] hover:bg-[#66CADA]/10 border-none rounded-full text-xs font-bold" data-id="element-422">
                    查看详情
                  </Button>
                </div>
              </div>
            </Card>
          </div>}

        {/* Smart Heatmap Service Card */}
        <Card onClick={() => window.location.href = '/heatmap'} className="p-5 bg-white border-none shadow-sm rounded-[32rpx] flex items-center justify-between cursor-pointer active:opacity-80 relative overflow-hidden" data-id="element-423">
          <div className="flex items-center gap-4 relative z-10" data-id="element-424">
            <div className="size-12 rounded-2xl bg-[#66CADA]/10 flex items-center justify-center text-[#66CADA]" data-id="element-425">
              <TrendingUp className="size-6" data-id="element-426" />
            </div>
            <div data-id="element-427">
              <h3 className="font-bold text-[#333333]" data-id="element-428">宿州文旅热图</h3>
              <p className="text-[20rpx] text-[#999999]" data-id="element-429">
                一图感知当前文旅热度
              </p>
            </div>
          </div>
          <Button variant="ghost" size="sm" className="text-[#66CADA] font-bold relative z-10" data-id="element-430">
            查看热图 <ChevronRight className="size-4 ml-1" data-id="element-431" />
          </Button>
          <div className="absolute right-0 top-0 w-24 h-full bg-[#66CADA]/5 -skew-x-12 translate-x-8" data-id="element-432" />
        </Card>

        {/* Service Grid */}
        <div className="bg-white rounded-[40rpx] p-6 shadow-sm border border-gray-100" data-id="element-433">
          <h3 className="text-lg font-bold text-[#333333] mb-6" data-id="element-434">我的服务</h3>
          <div className="grid grid-cols-4 gap-y-8" data-id="element-435">
            {serviceEntries.map((item, idx) => <div key={idx} className="flex flex-col items-center gap-2 cursor-pointer active:opacity-70 transition-opacity" data-id="element-436">
                <div className={`size-12 rounded-2xl bg-[#EEF8F8] flex items-center justify-center ${item.color}`} data-id="element-437">
                  <item.icon className="size-6" data-id="element-438" />
                </div>
                <span className="text-[22rpx] text-[#666666] font-medium text-center" data-id="element-439">
                  {item.title}
                </span>
              </div>)}
          </div>
        </div>

        {/* Featured Banner */}
        <div className="relative h-32 rounded-[32rpx] overflow-hidden shadow-sm" data-id="element-440">
          <img src={ASSETS.sportsBanner} alt="Sports" className="w-full h-full object-cover" data-id="element-441" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent flex items-center justify-between px-6" data-id="element-442">
            <div className="text-white" data-id="element-443">
              <h3 className="text-lg font-bold" data-id="element-444">跟着赛事游宿州</h3>
              <p className="text-xs text-white/80" data-id="element-445">看一场比赛，认识一座城市</p>
            </div>
            <div className="bg-white/20 backdrop-blur-md p-2 rounded-full" data-id="element-446">
              <ChevronRight className="size-5 text-white" data-id="element-447" />
            </div>
          </div>
        </div>

        {/* Elder Mode Card */}
        <Card className="p-5 bg-orange-50 border-none shadow-sm rounded-[32rpx] flex items-center justify-between cursor-pointer active:opacity-80" data-id="element-448">
          <div className="flex items-center gap-4" data-id="element-449">
            <div className="size-12 rounded-2xl bg-white flex items-center justify-center text-orange-500 shadow-sm" data-id="element-450">
              <Shield className="size-6" data-id="element-451" />
            </div>
            <div data-id="element-452">
              <h3 className="font-bold text-orange-900" data-id="element-453">长者版服务</h3>
              <p className="text-[20rpx] text-orange-700/70" data-id="element-454">
                大字版、语音讲解、专属适老服务
              </p>
            </div>
          </div>
        </Card>

        {/* Coupon Card */}
        <Card className="p-5 bg-red-50 border-none shadow-sm rounded-[32rpx] flex items-center justify-between cursor-pointer active:opacity-80" data-id="element-455">
          <div className="flex items-center gap-4" data-id="element-456">
            <div className="size-12 rounded-2xl bg-white flex items-center justify-center text-red-500 shadow-sm" data-id="element-457">
              <Ticket className="size-6" data-id="element-458" />
            </div>
            <div data-id="element-459">
              <h3 className="font-bold text-red-900" data-id="element-460">文旅消费券</h3>
              <p className="text-[20rpx] text-red-700/70" data-id="element-461">
                惠民补贴，领券享宿州好礼
              </p>
            </div>
          </div>
        </Card>
      </div>

      {/* Tab Bar */}
      <nav className="fixed bottom-0 left-0 right-0 h-20 bg-white/95 backdrop-blur-md border-t border-gray-100 flex items-center justify-around px-6 z-50 shadow-[0_-4px_12px_rgba(0,0,0,0.03)]" data-id="element-462">
        <div onClick={() => window.location.href = '/'} className="flex flex-col items-center gap-1 text-[#999999] cursor-pointer hover:text-[#66CADA] transition-colors" data-id="element-463">
          <HomeIcon className="size-6" data-id="element-464" />
          <span className="text-[22rpx]" data-id="element-465">首页</span>
        </div>
        <div onClick={() => window.location.href = '/explore'} className="flex flex-col items-center gap-1 text-[#999999] cursor-pointer hover:text-[#66CADA] transition-colors" data-id="element-466">
          <Compass className="size-6" data-id="element-467" />
          <span className="text-[22rpx]" data-id="element-468">游宿州</span>
        </div>
        <div className="flex flex-col items-center gap-1 text-[#66CADA] cursor-pointer" data-id="element-469">
          <Heart className="size-6" data-id="element-470" />
          <span className="text-[22rpx] font-bold" data-id="element-471">享服务</span>
        </div>
      </nav>
    </div>;
}